"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _BriefBlock = _interopRequireDefault(require("../../BriefBlock"));

require("../styles/_intent-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function IntentSection(_ref) {
  var onChangeField = _ref.onChangeField,
      targetAudience = _ref.targetAudience,
      keyMessage = _ref.keyMessage,
      callToAction = _ref.callToAction,
      canUpdateVideo = _ref.canUpdateVideo;
  return (/*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
      title: "INTENT"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "intent-section__block"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      placeholder: canUpdateVideo ? 'Enter target audience' : 'Target audience',
      label: "TARGET AUDIENCE",
      onChange: onChangeField('targetAudience'),
      defaultValue: targetAudience,
      small: true,
      disabled: !canUpdateVideo
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "intent-section__block"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      placeholder: canUpdateVideo ? 'Enter key message' : 'Key message',
      label: "KEY MESSAGE",
      defaultValue: keyMessage,
      onChange: onChangeField('keyMessage'),
      small: true,
      disabled: !canUpdateVideo
    })), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      placeholder: canUpdateVideo ? 'Enter call-to-action' : 'Call-to-action',
      label: "CALL-TO-ACTION",
      onChange: onChangeField('callToAction'),
      defaultValue: callToAction,
      small: true,
      disabled: !canUpdateVideo
    }))
  );
}

var _default = (0, _react.memo)(IntentSection);

exports.default = _default;